import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import {
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  TextField,
  createTheme,
  useMediaQuery,
} from '@mui/material';
import './style.css';
import LeadStore from '../../store/LeadStore';
import { isEmpty } from '../../utils/helper';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const EditProcessProcedureCompleted = observer(({ leadId, details, handleEditDetails }) => {
  const theme = createTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [formData, setFormData] = useState({
    id: details?.clientProcessProcedureId ?? null,
    leadId,
    siteCondition: details?.siteCondition?.split(','),
    siteConditionOther: details?.siteConditionOther,
    processCompleted: details?.processCompleted?.split(','),
    processCompletedOther: details?.processCompletedOther,
    howDidYouKnowAboutUs: details?.howDidYouKnowAboutUs,
    howDidYouKnowAboutUsOther: details?.howDidYouKnowAboutUsOther,
    createdBy: details?.CreatedBy,
    createdDate: details?.createdDate,
    updatedBy: details?.updatedBy,
    updatedDate: details?.updatedDate,
  });

  const [errors, setErrors] = useState({
    siteCondition: false,
    siteConditionOther: false,
    processCompleted: false,
    processCompletedOther: false,
    howDidYouKnowAboutUs: false,
    howDidYouKnowAboutUsOther: false,
  });

  const [errorMessages, setErrorMessages] = useState({
    siteCondition: '',
    siteConditionOther: '',
    processCompleted: '',
    processCompletedOther: '',
    howDidYouKnowAboutUs: '',
    howDidYouKnowAboutUsOther: '',
  });

  const siteConditionsList = [
    { id: 1, name: 'Slope Land' },
    { id: 2, name: '< 5 Km from Ring Road' },
    { id: 3, name: 'Loose soil' },
    { id: 4, name: '< 10 Km from Ring Road' },
    { id: 5, name: 'Water Logging' },
    { id: 6, name: 'Logistics Challenges' },
    { id: 7, name: 'Neighbours  Challenges' },
    { id: 8, name: 'No Water Supply' },
    { id: 9, name: 'No Elictricity Supply' },
    { id: 999, name: 'Other' },
  ];

  const processCompletedList = [
    { id: 1, name: 'Sales Meeting' },
    { id: 2, name: 'Office Tour' },
    { id: 3, name: 'Site Tour' },
    { id: 4, name: 'Client Site Visit' },
    { id: 5, name: 'Project & Process Orientation' },
    { id: 6, name: 'Introduction of PM & Architect' },
    { id: 7, name: 'Documents shared to inter departments' },
    { id: 8, name: 'Explanation of package details for PM & Architect' },
    { id: 9, name: 'Total Station Shated To Client' },
    { id: 10, name: 'Soil Test Details Shared With Client' },
    { id: 11, name: 'Payment Reciept Shared With Client' },
    { id: 12, name: 'Contract Hard Copy Shared With Client' },
    { id: 13, name: 'Contract Soft Copy Shared With Client' },
    { id: 14, name: 'Liasioning - Water, Electricity & Approvals' },
    { id: 999, name: 'Other' },
  ];

  const howDidYouKnowAboutUsList = [
    { id: 1, name: 'Facebook' },
    { id: 2, name: 'Instagram' },
    { id: 3, name: 'Youtube' },
    { id: 4, name: 'Google Blog' },
    { id: 5, name: 'Newspaper' },
    { id: 6, name: 'Work of mouth' },
    { id: 999, name: 'Other' },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Perform validation
    setErrors({ ...errors, [name]: isEmpty(value) });
  };

  const handleUpdateLeadKycSubmit = (e) => {
    e.preventDefault();

    const updatedErrors = {
      siteCondition: isEmpty(formData.siteCondition),
      siteConditionOther: formData.siteCondition?.indexOf('Other') > -1 && isEmpty(formData.siteConditionOther),
      processCompleted: isEmpty(formData.processCompleted),
      processCompleted: formData.processCompleted?.indexOf('Other') > -1 && isEmpty(formData.processCompletedOther),
      howDidYouKnowAboutUs: isEmpty(formData.howDidYouKnowAboutUs),
      howDidYouKnowAboutUs: formData.howDidYouKnowAboutUs === 'Other' && isEmpty(formData.howDidYouKnowAboutUsOther),
    };
    setErrors(updatedErrors);

    if (!Object.values(updatedErrors).some((error) => error === true)) {
      const payload = { ...formData };
      payload.siteCondition = payload.siteCondition?.join(',');
      payload.processCompleted = payload.processCompleted?.join(',');
      isEmpty(formData.id)
        ? LeadStore.createProcessAndProcedureCompleted(payload)
        : LeadStore.updateProcessAndProcedureCompleted(payload);
    }
  };

  useEffect(() => {
    LeadStore.updateProcessAndProcedureCompletedStatus && handleEditDetails();
  }, [LeadStore.updateProcessAndProcedureCompletedStatus]);

  return (
    <Paper sx={{ px: '30px', py: '20px', pb: '40px' }}>
      <Box
        id="lead-kyc-details-form"
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={(event) => {
          event.preventDefault();
          handleUpdateLeadKycSubmit(event);
        }}
      >
        <Stack spacing={4}>
          <Stack spacing={3}>
            <Grid rowGap={2} container>
              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ pr: isSmallScreen ? '0px' : '10px' }}>
                <Stack direction={'column'} spacing={3}>
                  <FormControl variant="standard" required error={Boolean(errors.siteCondition)}>
                    <InputLabel id="siteConditionlabel" required shrink={true}>
                      Site Condition
                    </InputLabel>
                    <Select
                      labelId="siteConditionlabel"
                      id="siteCondition"
                      name="siteCondition"
                      required
                      value={formData.siteCondition ?? []}
                      multiple
                      onChange={(e) => {
                        const {
                          target: { value },
                        } = e;
                        setFormData({
                          ...formData,
                          siteCondition: typeof value === 'string' ? value.split(',') : value,
                          siteConditionOther: isEmpty(value.find((item) => item === 'Other'))
                            ? null
                            : formData.siteConditionOther,
                        });
                        setErrors({
                          ...errors,
                          siteCondition: isEmpty(value),
                        });
                      }}
                      label="Site Condition"
                      renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </Box>
                      )}
                      MenuProps={MenuProps}
                    >
                      {siteConditionsList.map((site) => (
                        <MenuItem key={site.id} value={site.name}>
                          <Checkbox checked={formData.siteCondition?.indexOf(site.name) > -1} />
                          <ListItemText primary={site.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {formData.siteCondition?.indexOf('Other') > -1 && (
                    <TextField
                      label="Site Condition Other"
                      id="siteConditionOther"
                      size="small"
                      variant="standard"
                      required={formData.siteCondition?.indexOf('Other') > -1}
                      name="siteConditionOther"
                      multiline
                      rows={1}
                      value={formData.siteConditionOther ?? ''}
                      onChange={(e) => handleChange(e)}
                      error={Boolean(errors.siteConditionOther)}
                      sx={{ fontSize: '12px' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                  <FormControl variant="standard" required error={Boolean(errors.howDidYouKnowAboutUs)}>
                    <InputLabel id="howDidYouKnowAboutUsLabel" required shrink={true}>
                      How did you know about us
                    </InputLabel>
                    <Select
                      labelId="howDidYouKnowAboutUsLabel"
                      id="howDidYouKnowAboutUs"
                      name="howDidYouKnowAboutUs"
                      required
                      value={formData.howDidYouKnowAboutUs ?? ''}
                      onChange={(e) => {
                        const {
                          target: { value },
                        } = e;
                        setFormData({
                          ...formData,
                          howDidYouKnowAboutUs: value,
                          howDidYouKnowAboutUsOther: value !== 'Other' ? null : formData.howDidYouKnowAboutUsOther,
                        });
                        setErrors({
                          ...errors,
                          howDidYouKnowAboutUs: isEmpty(value),
                        });
                      }}
                      label="How did you know about us"
                      MenuProps={MenuProps}
                    >
                      {howDidYouKnowAboutUsList.map((site) => (
                        <MenuItem key={site.id} value={site.name}>
                          <ListItemText primary={site.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ pl: isSmallScreen ? '0px' : '10px' }}>
                <Stack direction={'column'} spacing={3}>
                  <FormControl variant="standard" required error={Boolean(errors.processCompleted)}>
                    <InputLabel id="processCompletedlabel" required shrink={true}>
                      Process Completed
                    </InputLabel>
                    <Select
                      labelId="processCompletedlabel"
                      id="processCompleted"
                      name="processCompleted"
                      required
                      value={formData.processCompleted ?? []}
                      multiple
                      onChange={(e) => {
                        const {
                          target: { value },
                        } = e;
                        setFormData({
                          ...formData,
                          processCompleted: typeof value === 'string' ? value.split(',') : value,
                          processCompletedkOther: isEmpty(value.find((item) => item === 'Other'))
                            ? null
                            : formData.processCompletedOther,
                        });
                        setErrors({
                          ...errors,
                          processCompleted: isEmpty(value),
                        });
                      }}
                      label="Process Completed"
                      renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </Box>
                      )}
                      MenuProps={MenuProps}
                    >
                      {processCompletedList.map((site) => (
                        <MenuItem key={site.id} value={site.name}>
                          <Checkbox checked={formData.processCompleted?.indexOf(site.name) > -1} />
                          <ListItemText primary={site.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {formData.processCompleted?.indexOf('Other') > -1 && (
                    <TextField
                      label="Process Completed Other"
                      id="processCompletedOther"
                      size="small"
                      variant="standard"
                      required={formData.processCompleted?.indexOf('Other') > -1}
                      name="processCompletedOther"
                      multiline
                      rows={1}
                      value={formData.processCompletedOther ?? ''}
                      onChange={(e) => handleChange(e)}
                      error={Boolean(errors.processCompletedOther)}
                      sx={{ fontSize: '12px' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                  {formData.howDidYouKnowAboutUs === 'Other' && (
                    <TextField
                      label="How did you know about us Other"
                      id="howDidYouKnowAboutUsOther"
                      size="small"
                      variant="standard"
                      required={formData.howDidYouKnowAboutUs === 'Other'}
                      name="howDidYouKnowAboutUsOther"
                      multiline
                      rows={1}
                      value={formData.howDidYouKnowAboutUsOther ?? ''}
                      onChange={(e) => handleChange(e)}
                      error={Boolean(errors.howDidYouKnowAboutUsOther)}
                      sx={{ fontSize: '12px' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                </Stack>
              </Grid>
            </Grid>
          </Stack>
          <Stack direction={'row'} sx={{ ml: 'auto' }} alignSelf={isSmallScreen ? '' : 'end'} spacing={2}>
            <Button variant="outlined" color="inherit" fullWidth size="small" onClick={() => handleEditDetails(false)}>
              Cancel
            </Button>
            <Button variant="contained" type="submit" fullWidth color="primary" size="small">
              Update
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Paper>
  );
});
